<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container>
          <label>Peso (kg)</label>
          <md-input
            id="weight"
            v-model="exam.fields.weight"
            v-validate="'required'"
            data-vv-validate-on="none"
            name="weight"
            title="Peso (kg)"
            placeholder="Peso (kg)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.weight"
            v-mask="weight"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>Altura (cm)</label>
          <md-input
            id="height"
            v-model="exam.fields.height"
            v-validate="'required'"
            v-mask="`###`"
            data-vv-validate-on="none"
            name="height"
            title="Altura (cm)"
            placeholder="Altura (cm)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.height"
            v-mask="`###`"
            type="hidden"
          >
        </md-input-container>
        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>
    <div class="calc-card__result">
      <template>
        <p>
          Resultado: <span>{{ exam.result }}</span> {{ exam.classification }}
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'CalcIndiceMassaCorporalAdultos',

  data: () => {
    return {
      exam: {
        fields: {
          weight: null,
          height: null
        },
        result: 0,
        classification: ''
      },
      weight: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 3
      })
    }
  },
  methods: {
    calculate() {
      if (this.exam.fields.weight && this.exam.fields.height) {
        const weight = +this.exam.fields.weight
        let height = +this.exam.fields.height

        height = height / 100
        this.exam.result = (weight / (height * height)).toFixed(1)

        if (this.exam.result <= 18.5) {
          this.exam.classification = ' - Magreza'
        } else if (this.exam.result >= 18.5 && this.exam.result <= 24.9) {
          this.exam.classification = ' - Normal'
        } else if (this.exam.result >= 25.0 && this.exam.result <= 29.9) {
          this.exam.classification = ' - Sobrepeso'
        } else if (this.exam.result >= 30.0 && this.exam.result <= 39.9) {
          this.exam.classification = ' - Obesidade'
        } else if (this.exam.result >= 40) {
          this.exam.classification = ' - Obesidade grave'
        }
      }
    }
  }
}
</script>

